var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.isCliked,class:_vm.tutorial ? (_vm.disabled ? 'zone disabled' : 'zone tutorial') : 'zone',style:(`position:absolute;top: ${_vm.zone.position.top}%;left:${_vm.zone.position.left}%;right:${_vm.zone.position.right}%;bottom:${_vm.zone.position.bottom}%;opacity:0.6`),attrs:{"data-type":_vm.zone.zone_type},on:{"click":_vm.zoneCliked}},[(
      _vm.currentChapter.lastZone &&
        _vm.currentChapter.lastZone.planche_zone.id === _vm.zone.id
    )?_c('span',{staticClass:"zone-reminder"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }